export const toPx = value => typeof value === 'number' ? `${value}px` : value;